/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScanDataDTOFromJSON, ScanDataDTOToJSON, } from './ScanDataDTO';
import { AsinPoolStatsDTOFromJSON, AsinPoolStatsDTOToJSON, } from './AsinPoolStatsDTO';
import { InventoryQualityDTOFromJSON, InventoryQualityDTOToJSON, } from './InventoryQualityDTO';
import { OrderStatsDTOFromJSON, OrderStatsDTOToJSON, } from './OrderStatsDTO';
import { ProductStagingQualityDTOFromJSON, ProductStagingQualityDTOToJSON, } from './ProductStagingQualityDTO';
/**
 * Check if a given object implements the AnalyticsDashboardDTO interface.
 */
export function instanceOfAnalyticsDashboardDTO(value) {
    return true;
}
export function AnalyticsDashboardDTOFromJSON(json) {
    return AnalyticsDashboardDTOFromJSONTyped(json, false);
}
export function AnalyticsDashboardDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'scanData': json['scanData'] == null ? undefined : ScanDataDTOFromJSON(json['scanData']),
        'keywordAsinsPool': json['keywordAsinsPool'] == null ? undefined : (json['keywordAsinsPool'].map(AsinPoolStatsDTOFromJSON)),
        'storeAsinsPool': json['storeAsinsPool'] == null ? undefined : (json['storeAsinsPool'].map(AsinPoolStatsDTOFromJSON)),
        'productPoolQualityData': json['productPoolQualityData'] == null ? undefined : (json['productPoolQualityData'].map(ProductStagingQualityDTOFromJSON)),
        'inventoryQualityData': json['inventoryQualityData'] == null ? undefined : (json['inventoryQualityData'].map(InventoryQualityDTOFromJSON)),
        'orderStatsData': json['orderStatsData'] == null ? undefined : (json['orderStatsData'].map(OrderStatsDTOFromJSON)),
    };
}
export function AnalyticsDashboardDTOToJSON(json) {
    return AnalyticsDashboardDTOToJSONTyped(json, false);
}
export function AnalyticsDashboardDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'scanData': ScanDataDTOToJSON(value['scanData']),
        'keywordAsinsPool': value['keywordAsinsPool'] == null ? undefined : (value['keywordAsinsPool'].map(AsinPoolStatsDTOToJSON)),
        'storeAsinsPool': value['storeAsinsPool'] == null ? undefined : (value['storeAsinsPool'].map(AsinPoolStatsDTOToJSON)),
        'productPoolQualityData': value['productPoolQualityData'] == null ? undefined : (value['productPoolQualityData'].map(ProductStagingQualityDTOToJSON)),
        'inventoryQualityData': value['inventoryQualityData'] == null ? undefined : (value['inventoryQualityData'].map(InventoryQualityDTOToJSON)),
        'orderStatsData': value['orderStatsData'] == null ? undefined : (value['orderStatsData'].map(OrderStatsDTOToJSON)),
    };
}
